import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import type { RespuestaInvitacion } from '@eventos-cien/shared';
import { Button } from '../../components/Button';
import { Callout } from '../../components/Callout';
import { Screen } from '../../components/Screen';
import { CargaPagina } from '../../components/Spinner';
import { ThemeProvider } from '../../theme/ThemeProvider';
import { api, ApiError } from '../../lib/api';
import { Boleto } from './Boleto';
import { Invalida } from './Invalida';
import { Landing } from './Landing';

export function InvitacionScreen() {
  const { token = '' } = useParams();
  const [estado, setEstado] = useState<'cargando' | 'lista' | 'error'>('cargando');
  const [data, setData] = useState<RespuestaInvitacion | null>(null);
  const [errorCarga, setErrorCarga] = useState<string | null>(null);

  const cargar = useCallback(() => {
    setEstado('cargando');
    api<RespuestaInvitacion>(`/i/${encodeURIComponent(token)}`)
      .then((r) => {
        setData(r);
        setEstado('lista');
      })
      .catch((e) => {
        setErrorCarga(e instanceof ApiError ? e.message : 'No se pudo abrir la invitación');
        setEstado('error');
      });
  }, [token]);

  useEffect(cargar, [cargar]);

  if (estado === 'cargando') return <CargaPagina />;
  if (estado === 'error') {
    return (
      <Screen centrado>
        <div className="space-y-4">
          <Callout tono="error">{errorCarga}</Callout>
          <Button variante="secundario" bloque onClick={cargar}>
            Reintentar
          </Button>
        </div>
      </Screen>
    );
  }
  if (!data) return null;
  if (data.vista === 'invalida') return <Invalida motivo={data.motivo} />;

  return (
    <ThemeProvider tema={data.evento.tema}>
      {data.vista === 'boleto' ? (
        <Boleto boleto={data} />
      ) : (
        <Landing
          token={token}
          cupo={data.cupo}
          asesorNombre={data.asesorNombre}
          evento={data.evento}
          onRegistrado={setData}
        />
      )}
    </ThemeProvider>
  );
}
